import React from 'react'
import { Link } from 'react-router-dom'

const Cta = () => {
    return (
        <>
            <div className="cta-section-two">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="cta-box-two">
                                <div className="heading-box text-center light">
                                    <p>Uniqo</p>
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        We are optimists who love to work together
                                    </h2>
                                    <Link
                                        to="/Contact"
                                        className="btn btn-light btn-theme animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        style={{ position: "relative" }}

                                    >
                                        Get In Touch <span>+</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Cta
